import { Box } from '@mui/material'
import { ImageOutlined } from '@mui/icons-material'

type LogoProps = {
  url?: string
  alt?: string
}

export const InstitutionLogo = ({ url, alt }: LogoProps) => {
  return (
    <>
      {url ? (
        <Box
          component="img"
          alt={alt || 'no-institution-alt'}
          data-testid="JobOffers__JobOfferCard__institution_image"
          src={url}
          sx={[
            {
              height: 45,
              width: 45,
            },
            (theme) => ({
              border: 'solid',
              borderRadius: 2,
              borderWidth: 1,
              borderColor: theme.palette.border.subtle,
              width: 40,
              height: 40,
              objectFit: 'contain',
            }),
          ]}
        />
      ) : (
        <ImageOutlined
          sx={(theme) => ({
            border: 'solid',
            borderRadius: '4px',
            borderWidth: '1px',
            borderColor: theme.palette.border.subtle,
            width: 40,
            height: 40,
            color: theme.palette.text.disabled,
          })}
        />
      )}
    </>
  )
}
